export default __webpack_public_path__ + "static/media/warner_logo.6ec3796b.png";